import Vue from 'vue'
import { HubConnectionBuilder, LogLevel, HubConnectionState } from '@microsoft/signalr'
import { EventBus } from '@/plugins/event-bus'
import { getSignalRNegotiateUrl } from '@/config/runtimeConfig'
import { applyCmsBuildHeader } from '@/utils/cmsBuildHeader'
import store from '@/store'
var signalRconnection = {}

const initSignalR = async () => {
  if (signalRconnection.state !== HubConnectionState.Connected && signalRconnection.state !== HubConnectionState.Connecting) {
    try {
      const connectionInfoResponse = await fetch(getSignalRNegotiateUrl(), {
        method: "POST",
        headers: applyCmsBuildHeader({
          "x-my-user-id": `${store.state.User.group.group_id}`
        })
      });

      // Check if the response is ok and has content
      if (!connectionInfoResponse.ok) {
        throw new Error(`HTTP error! status: ${connectionInfoResponse.status}`);
      }

      // Check if response has content
      const responseText = await connectionInfoResponse.text();
      if (!responseText) {
        throw new Error('Empty response from negotiate endpoint');
      }

      // Parse the JSON
      const connectionInfo = JSON.parse(responseText);

      // Validate that we have the required properties
      if (!connectionInfo.url || !connectionInfo.accessToken) {
        throw new Error('Invalid connection info: missing url or accessToken');
      }

      signalRconnection = new HubConnectionBuilder()
        .withUrl(connectionInfo.url, { accessTokenFactory: () => connectionInfo.accessToken })
        .configureLogging(LogLevel.Information).build()


    // .withAutomaticReconnect(
      subscribeForReconnecting(signalRconnection)
      subscribeForReconnected(signalRconnection)
      subscribeForOnClose(signalRconnection)

      subscribeFormedicationRefreshEvent(signalRconnection)
      subscribeMedicationCallEvent(signalRconnection)
      subscribeForPharmacyCallEvent(signalRconnection)
      subscribePhysicianPageEvent(signalRconnection)

      await start()
    } catch (error) {
      console.error('Failed to initialize SignalR:', error);
      EventBus.$emit('signalrError', { error: (error && error.message) ? error.message : String(error), stage: 'init' })
      // Optionally retry after a delay
      setTimeout(() => initSignalR(), 5000);
    }
  }
}

const start = async () => {
  try {
    if (signalRconnection.state !== HubConnectionState.Connected) {
      await signalRconnection.start()
      console.assert(signalRconnection.state === HubConnectionState.Connected)
      console.log('SignalR Connected.')
    }
  } catch (err) {
    console.assert(signalRconnection.state === HubConnectionState.Disconnected)
    console.log(err)
    EventBus.$emit('signalrError', { error: (err && err.message) ? err.message : String(err), stage: 'start' })
    setTimeout(() => start(), 5000)
  }
}

const stop = async () => {
  try {
    await signalRconnection.stop()
    // await signalRconnection.dispose()
    // console.assert(signalRconnection.state === HubConnectionState.Disconnected)
    // console.log('SignalR Disconnected.')
  } catch (err) {
    console.log(err)
    EventBus.$emit('signalrError', { error: (err && err.message) ? err.message : String(err), stage: 'stop' })
  }
}

const sendMessage = async ({ user, message }) => {
  try {
    const ret = await signalRconnection.invoke('sendToUser', user, message)
    console.log(ret)
  } catch (err) {
    console.error(err)
    EventBus.$emit('signalrError', { error: (err && err.message) ? err.message : String(err), stage: 'sendMessage' })
  }
}

const subscribeFormedicationRefreshEvent= async (connection) => {
  connection.on('medicationRefreshEvent', (message) => {
    console.log('medicationRefreshEvent')
    EventBus.$emit('medicationRefreshEvent', message)
  })
} 

const subscribePhysicianPageEvent= async (connection) => {
  connection.on('physicianPageEvent', (message) => {
    console.log('PhysicianPageEvent Trigger')
    EventBus.$emit('physicianPageEvent', message)
  })
} 

const subscribeMedicationCallEvent = async (connection) => {
  connection.on('medicationCallEvent', (message) => {
    console.log('medicationCallEvent')
    console.log(message)
    EventBus.$emit('medicationCallEvent', message)
  })
}

const subscribeForPharmacyCallEvent = async (connection) => {
  connection.on('pharmacyCallEvent', (message) => {
    console.log(message)
    EventBus.$emit('pharmacyCallEvent', message)
  })
}
const subscribeForReconnecting = async (connection) => {
  connection.onreconnecting(error => {
    console.log('ReConnecting')
    console.assert(connection.state === HubConnectionState.Reconnecting)
    EventBus.$emit('onreconnecting', error)
  })
}

const subscribeForReconnected = async (connection) => {
  connection.onreconnected(connectionId => {
    console.assert(connection.state === HubConnectionState.Connected)
    EventBus.$emit('onreconnected', connectionId)
  })
}

const subscribeForOnClose = async (connection) => {
  connection.onclose(async () => {
    EventBus.$emit('onclose')
    await initSignalR()
  })
}

export {
  initSignalR,
  sendMessage,
  stop
}
